export default "__VITE_PUBLIC_ASSET__3636ca68__"